/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */

export type ConversationAssistantUIModes = 'mini-modal' | 'sidebar' | undefined;

export const AI_MATE_ATTRIBUTES = {
	agentCreatorType: 'agentCreatorType',
	agentId: 'agentId',
	agentVisibility: 'agentVisibility',
	agentExternalConfigReference: 'agentExternalConfigReference',
	agentActions: 'agentActions',
	agentIsDefault: 'agentIsDefault',
	agentIsVerified: 'agentIsVerified',
	conversationChannelId: 'conversationChannelId',
	experienceId: 'experienceId',
	fullScreen: 'fullScreen',
	mode: 'mode',
	product: 'product',
	productHeader: 'productHeader',
	singleInstrumentationID: 'singleInstrumentationID',
	sharedFeaturesInstrumentationId: 'sharedFeaturesInstrumentationId',
} as const;

export type AIMateAgentAttributeType = {
	[AI_MATE_ATTRIBUTES.agentCreatorType]: string | null;
	[AI_MATE_ATTRIBUTES.agentId]: string | null;
	[AI_MATE_ATTRIBUTES.agentVisibility]: string | null;
	[AI_MATE_ATTRIBUTES.agentExternalConfigReference]: string | null;
	[AI_MATE_ATTRIBUTES.agentActions]: string[];
	[AI_MATE_ATTRIBUTES.agentIsDefault]: boolean | null;
	[AI_MATE_ATTRIBUTES.agentIsVerified]: boolean | null;
};

export type AIMateAttributeType = AIMateAgentAttributeType & {
	[AI_MATE_ATTRIBUTES.conversationChannelId]: string;
	[AI_MATE_ATTRIBUTES.experienceId]: string;
	[AI_MATE_ATTRIBUTES.fullScreen]: boolean;
	[AI_MATE_ATTRIBUTES.mode]: string | undefined;
	[AI_MATE_ATTRIBUTES.product]: string;
	[AI_MATE_ATTRIBUTES.productHeader]: string;
	[AI_MATE_ATTRIBUTES.singleInstrumentationID]: string;
	[AI_MATE_ATTRIBUTES.sharedFeaturesInstrumentationId]?: string;
};

export type AnalyticsPropertiesContextProps = {
	propertiesRef: React.MutableRefObject<AIMateAttributeType>;
	mode: ConversationAssistantUIModes;
	setAnalyticsPropertiesWithoutRerender: (properties: Partial<AIMateAttributeType>) => void;
};

export type SharedFeaturesInstrumentationIdContextProps = {
	sharedFeaturesInstrumentationId: string | undefined;
	isInSmartCreateFlow: boolean | undefined;
};
